import React, { useEffect, useState } from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Api from "../../api";
import Select from "../Select";
import { LANGUAGES } from "../../consts";
import { showNotification } from "../../utils";
import "./pace.css";
import "./subtype_manage.css";

const Subtype_manage = () => {
  const [subtypes, setSubtypes] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [loadError, setLoadError] = useState("");
  const [draftName, setDraftName] = useState("");
  const [draftLanguage, setDraftLanguage] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editingName, setEditingName] = useState("");
  const [pendingDelete, setPendingDelete] = useState(null);
  const [saving, setSaving] = useState(false);

  const loadSubtypes = async () => {
    const result = await Api.Subtype.List();
    if (!result?.ok || !Array.isArray(result.data)) {
      setLoadError(result?.message || "No se pudieron cargar los sub-tipos");
      setLoaded(true);
      return;
    }
    setLoadError("");
    setSubtypes(result.data);
    setLoaded(true);
  };

  useEffect(() => {
    loadSubtypes();
  }, []);

  const addSubtype = async () => {
    const name = draftName.trim();
    if (!name) {
      showNotification("Error", "Escribe el nombre del taller", "warning");
      return;
    }
    if (!draftLanguage) {
      showNotification("Error", "Selecciona un idioma", "warning");
      return;
    }
    setSaving(true);
    try {
      const result = await Api.Subtype.Create({
        subtype: name,
        language: draftLanguage,
      });
      if (!result?.ok) {
        showNotification(
          "Error",
          result?.message || "No se pudo agregar el sub-tipo",
          "danger"
        );
        return;
      }
      setDraftName("");
      showNotification("¡Éxito!", "Sub-tipo agregado", "success");
      loadSubtypes();
    } catch (error) {
      showNotification("Error", error.message, "danger");
    } finally {
      setSaving(false);
    }
  };

  const saveName = async (item) => {
    const name = editingName.trim();
    if (!name) {
      showNotification("Error", "Escribe el nombre del taller", "warning");
      return;
    }
    setSaving(true);
    try {
      const result = await Api.Subtype.Update(item.id, {
        subtype: name,
        language: item.language,
      });
      if (!result?.ok) {
        showNotification(
          "Error",
          result?.message || "No se pudo actualizar el sub-tipo",
          "danger"
        );
        return;
      }
      setEditingId(null);
      showNotification("¡Éxito!", "Sub-tipo actualizado", "success");
      loadSubtypes();
    } catch (error) {
      showNotification("Error", error.message, "danger");
    } finally {
      setSaving(false);
    }
  };

  const rowsFor = (language) =>
    subtypes.filter(
      (item) => String(item.language || "").toUpperCase() === language
    );

  const renderTable = (rows) => (
    <div className="pace_info-tables">
      <table className="subtype-list-table">
        <thead>
          <tr>
            <th className="subtype-col-name">Nombre</th>
            <th className="subtype-col-language">Idioma</th>
            <th className="subtype-col-actions"></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((item) => (
            <tr key={item.id}>
              <td className="subtype-col-name">
                {editingId === item.id ? (
                  <input
                    type="text"
                    value={editingName}
                    onChange={(event) => setEditingName(event.target.value)}
                  />
                ) : (
                  item.subtype
                )}
              </td>
              <td className="subtype-col-language">{item.language}</td>
              <td className="subtype-col-actions">
                {editingId === item.id ? (
                  <button
                    type="button"
                    className="pace_search-button"
                    disabled={saving}
                    onClick={() => saveName(item)}
                  >
                    Guardar
                  </button>
                ) : (
                  <>
                    <button
                      type="button"
                      className="subtype-icon-button"
                      aria-label="Editar"
                      onClick={() => {
                        setPendingDelete(null);
                        setEditingId(item.id);
                        setEditingName(item.subtype);
                      }}
                    >
                      <EditOutlinedIcon fontSize="small" />
                    </button>
                    <button
                      type="button"
                      className="subtype-icon-button"
                      aria-label="Eliminar"
                      onClick={() => {
                        setEditingId(null);
                        setPendingDelete(item);
                      }}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const confirmDelete = async () => {
    if (!pendingDelete) return;
    setSaving(true);
    try {
      const result = await Api.Subtype.Remove(pendingDelete.id);
      if (!result?.ok) {
        showNotification(
          "Error",
          result?.message || "No se pudo eliminar el sub-tipo",
          "danger"
        );
        return;
      }
      setPendingDelete(null);
      showNotification("¡Éxito!", "Sub-tipo eliminado", "success");
      loadSubtypes();
    } catch (error) {
      showNotification("Error", error.message, "danger");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="pace_container">
      <div className="pace_show">
        <h1>Sub-tipos</h1>
        <h4>Añadir nuevo nombre de taller</h4>
        <input
          type="text"
          placeholder="Nombre del taller"
          value={draftName}
          onChange={(event) => setDraftName(event.target.value)}
        />
        <Select
          name="subtype-language"
          options={LANGUAGES}
          value={LANGUAGES.find((language) => language.value === draftLanguage)}
          onChange={(selected) => setDraftLanguage(selected.value)}
          placeholder="Idioma"
        />
        <div className="subtype-manage-actions">
          <input
            className="pace_search-button"
            type="button"
            value="Añadir"
            disabled={saving}
            onClick={addSubtype}
          />
        </div>
        {!loaded ? (
          <p>Cargando…</p>
        ) : loadError ? (
          <p>{loadError}</p>
        ) : (
          <>
            <h4>Francés</h4>
            {rowsFor("FR").length > 0 ? (
              renderTable(rowsFor("FR"))
            ) : (
              <p>Sin subtipos</p>
            )}
            <h4>Inglés</h4>
            {rowsFor("EN").length > 0 ? (
              renderTable(rowsFor("EN"))
            ) : (
              <p>Sin subtipos</p>
            )}
          </>
        )}
        {pendingDelete && (
          <div className="subtype-delete-confirm">
            <p>¿Eliminar el sub-tipo {pendingDelete.subtype}?</p>
            <div className="subtype-manage-actions">
              <input
                className="pace_search-button"
                type="button"
                value="Cancelar"
                onClick={() => setPendingDelete(null)}
              />
              <input
                className="pace_clear-button"
                type="button"
                value="Confirmar"
                disabled={saving}
                onClick={confirmDelete}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Subtype_manage;
